import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SVGComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
        <Path
            d="M13.4142 5.41421L12.8839 5.94454L13.4142 5.41421ZM4 12L4.53033 12.5303L11.1161 5.94454L10.5858 5.41421L10.0555 4.88388L3.46967 11.4697L4 12ZM13.4142 5.41421L12.8839 5.94454L19.4697 12.5303L20 12L20.5303 11.4697L13.9445 4.88388L13.4142 5.41421ZM10.5858 5.41421L11.1161 5.94454C11.6043 5.45639 12.3957 5.45639 12.8839 5.94454L13.4142 5.41421L13.9445 4.88388C12.8706 3.80994 11.1294 3.80994 10.0555 4.88388L10.5858 5.41421Z"
            fill={designSystem.colors.surge}
        />
        <Path
            d="M6 16L11.2929 10.7071C11.6834 10.3166 12.3166 10.3166 12.7071 10.7071L18 16"
            stroke={designSystem.colors.surge}
            strokeWidth={1.5}
        />
        <Path
            d="M8 20L11.6464 16.3536C11.8417 16.1583 12.1583 16.1583 12.3536 16.3536L16 20"
            stroke={designSystem.colors.surge}
            strokeWidth={1.5}
        />
    </Svg>
);
export default SVGComponent;
